"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonoidSum = exports.SemigroupSum = exports.hundred = exports.minusOne = exports.one = exports.zero = exports.Numeric = void 0;
/**
 * Encapsulates a numeric value.
 * Provides operators to perform calculations.
 */
class Numeric {
    _value;
    _trail;
    /**
     * Creates a new Numeric instance.
     *
     * @param _value the numeric value (e.g. 50)
     */
    constructor(_value, _trail = {
        kind: "NumericCreate"
    }) {
        this._value = _value;
        this._trail = _trail;
    }
    toString = () => `Numeric(${this._value})`;
    toJSON = () => ({
        kind: "Numeric",
        value: this._value,
        trail: this._trail
    });
    /**
     * @returns a clone of the Numeric object with the given trail label.
     */
    withLabel = (label) => new Numeric(this._value, { ...this._trail, label });
    /**
     * Overwrites the label of this Numeric object.
     */
    setLabel = (label) => {
        // eslint-disable-next-line functional/no-expression-statements, functional/immutable-data
        this._trail.label = label;
        return this;
    };
    /**
     * @returns the numeric value.
     */
    value = () => this._value;
    /**
     * Adds two Numeric.
     */
    plus = (other) => new Numeric(this._value + other._value, {
        kind: "NumericAdd",
        left: this,
        right: other
    });
    /**
     * Subtracts two Numeric.
     */
    minus = (other) => new Numeric(this._value - other._value, {
        kind: "NumericSub",
        left: this,
        right: other
    });
    /**
     * Multiplies two Numeric.
     */
    times = (other) => new Numeric(this._value * other._value, {
        kind: "NumericTimes",
        left: this,
        right: other
    });
    /**
     * Divides two Numeric.
     * Returns undefined if the divisor is zero.
     */
    over = (other) => other._value !== 0
        ? new Numeric(this._value / other._value, {
            kind: "NumericOver",
            left: this,
            right: other
        })
        : undefined;
    /**
     * Divides two Numeric.
     * Returns the orElse Numeric if the divisor is zero.
     */
    overOrElse = (other, orElse) => other._value !== 0
        ? new Numeric(this._value / other._value, {
            kind: "NumericOver",
            left: this,
            right: other
        })
        : new Numeric(orElse, {
            kind: "NumericOver",
            left: this,
            right: other
        });
    /**
     * Returns the inverse of the Numeric object.
     */
    inverse = () => exports.one.over(this);
    /**
     * Changes the sign of the Numeric object.
     */
    negate = () => this.times(exports.minusOne);
    /**
     * @returns true if the amounts of the two Numeric objects are equal.
     */
    eq = (other) => this._value === other._value;
    /**
     * @returns true if the amount of the Numeric object is zero.
     */
    eqZero = () => this._value === 0;
    /**
     * @returns true if the amount of the first Numeric object is
     * greater to the amount of the second Numeric object.
     */
    gt = (other) => this._value > other._value;
    /**
     * @returns true if the amount of the first Numeric object is
     * less to the amount of the second Numeric object.
     */
    lt = (other) => other.gt(this);
    /**
     * @returns true if the amount of the first Numeric object is
     * greater or equal to the amount of the second Numeric object.
     */
    gte = (other) => this._value >= other._value;
    /**
     * @returns true if the amount of the first Numeric object is
     * less or equal to the amount of the second Numeric object.
     */
    lte = (other) => other.gte(this);
}
exports.Numeric = Numeric;
exports.zero = new Numeric(0, {
    kind: "NumericCreate",
    label: "CONSTANT"
});
exports.one = new Numeric(1, {
    kind: "NumericCreate",
    label: "CONSTANT"
});
exports.minusOne = new Numeric(-1, {
    kind: "NumericCreate",
    label: "CONSTANT"
});
exports.hundred = new Numeric(100, {
    kind: "NumericCreate",
    label: "CONSTANT"
});
exports.SemigroupSum = {
    concat: (a, b) => a.plus(b)
};
exports.MonoidSum = {
    ...exports.SemigroupSum,
    empty: exports.zero
};
